/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { useEffect, useState } from "react";
import { AccountCircleIcon, AlertCircleIcon, CheckFillIcon, DescriptionIcon, LogoutIcon, NotificationIcon, TutorialIcon } from "../icons.component";
import { SessionSelector } from "../molecules";
import { connect } from "react-redux";
import { AuthenticationType } from "src/types/repository.type";
import Select from "../atoms/select.component";
import { setCurrentApplication, setCurrentLicense } from "src/store/actions/settings.action";
import { getAppsSorted, getLicenseFullName, getSortedList } from "src/utils/global";
import { MenuProps } from "antd";
import { Button } from "../atoms";

interface HeaderProps {
  section?: string,
  auth?: AuthenticationType,
  onLogout?: any,
  user?: any,
  settings?: any,
  setCurrentLicense?: any,
  setCurrentApplication?: any,
};

const Header = ({
  section,
  auth,
  onLogout,
  user,
  settings,
  setCurrentLicense,
  setCurrentApplication,
} : HeaderProps) => {
  const [licenses, setLicenses] = useState([]);
  const [currentLicenseId, setCurrentLicenseId] = useState('');

  useEffect(() => {
    getLicensesSelectorItems();
  }, [user.licenses]);

  useEffect(() => {
    setCurrentLicenseId(settings?.currentLicense?.licenseID || '');
    handleSetCurrentApplication();
  }, [settings.currentLicense]);

  const itemsMenu: MenuProps['items'] = [
    {
      key: 'go-account',
      label: (
        <a className="app-menu-selector" onClick={()=>handleActionMenu()}>
          <span className="app-menu-selector__icon"><AccountCircleIcon /></span>Mi Cuenta
        </a>
      ),
    },
    {
      type: 'divider',
    },
    {
      key: 'legal-documents',
      label: (
        <a className="app-menu-selector" onClick={()=>handleActionMenu()}>
          <span className="app-menu-selector__icon"><DescriptionIcon /></span>Avisos legales
        </a>
      ),
    },
    {
      key: 'about',
      label: (
        <a className="app-menu-selector" onClick={()=>handleActionMenu()}>
          <span className="app-menu-selector__icon"><AlertCircleIcon /></span>Acerca de
        </a>
      ),
    },
    {
      type: 'divider',
    },
    {
      key: 'close-session',
      label: (
        <div className="app-close-session"><Button className='btn-primary--plane' onClick={()=>onLogout()} hasIcon icon={<LogoutIcon />}>Cerrar Sesión</Button></div>
      ),
    },
  ];

  const getLicensesSelectorItems = () => {
    let licenses:any = [];
    if (user?.licenses?.length > 0) {
      licenses = user?.licenses?.map((license:any) => {
        return {
          label: <div className="app-header__licenses__content"><div className="app-header__licenses-label">
            {getLicenseFullName(license)}
            <span className="app-header__licenses-sublabel">{license.ownerEmail || ''}</span>
          </div><div className="app-header__licenses__icon"><CheckFillIcon /></div></div>,
          value: license.licenseID,
          labelHidden: `${getLicenseFullName(license)} ${license.ownerEmail}`,
        };
      });
    }
    licenses = getSortedList(licenses, 'labelHidden');
    setLicenses(licenses);
  };

  const handleChangeLicense = (licenseId:string) => {
    if(licenseId) {
      let selectedLicense = user?.licenses?.find((item:any) => item.licenseID === licenseId);
      if (selectedLicense) {
        setCurrentLicense(selectedLicense);
      }
    }
  };

  const handleSetCurrentApplication = () => {
    if (settings?.currentLicense?.apps?.length > 0) {
      let sortedApps = getAppsSorted(settings?.currentLicense?.apps);
      setCurrentApplication(sortedApps[0]);
    }
  };

  const handleActionMenu = () => {

  };

  return (
    <div className="app-header">
      <div className="app-header__section">
        <h1 className="subtitle-lg">{section}</h1>
        <div className="app-header__separator"></div>
        <Select showSearch searcheableLabel="labelHidden" autoClearSearchValue value={currentLicenseId} className="app-header__licenses-selector" options={licenses} onChange={(event:any)=>{
          handleChangeLicense(event);
        }}/>
      </div>
      <div className="app-header__controls">
        <div className="app-header__menu">
          <button className="app-btn-icon app-btn-icon--vertical">
            <TutorialIcon />
            <span className="text text--xs">Tutoriales</span>
          </button>
          <button className="app-btn-icon app-btn-icon--vertical">
            <NotificationIcon />
            <span className="text text--xs">Notificaciones</span>
          </button>
        </div>
        <div className="app-header__separator"></div>
        <SessionSelector avatar={user?.info?.profileImage} heading={`${user?.info?.firstName || ''} ${user?.info?.lastName || ''} ${user?.info?.secondLastName || ''}`} extract={auth?.userAccount?.email} itemsDropdown={itemsMenu}/>
      </div>
    </div>
  );
};

const mapStateToProps = (state:any) => ({
  auth: state.auth,
  user: state.user,
  settings: state.settings,
});

const mapDispatchToProps = {
  setCurrentLicense,
  setCurrentApplication,
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
